import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'semantic-ui-react';
import cx from 'classnames';

export class SemanticFormField extends PureComponent {
  static propTypes = {
    as: PropTypes.any,
    input: PropTypes.object,
    meta: PropTypes.object,
    // width: PropTypes.number.isRequired,
    // containerClass: PropTypes.string.isRequired,
    // size: PropTypes.string.isRequired,
    // className: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    field: PropTypes.object,
  };
  handleChange = (event, data) => {
    const { as, input } = this.props;
    const value = as.name === 'FormCheckbox' ? data.checked : data.value;
    input.onChange(value);
  };

  render() {
    const {
      input,
      field,
      meta: { touched, error, warning },
      as: As = Input,
      ...props
    } = this.props;

    // This avoid warning message in the console when try to pass a property "value" in Checkbox component,
    // it's because the checkbox use the property "checked" to set the current value
    if (As.name === 'FormCheckbox') {
      input.checked = !!input.value;
      delete input.value;
    }

    return (
      <Form.Field>
        <As
          {...props}
          {...input}
          fluid
          placeholder={field ? field.name : ''}
          onChange={this.handleChange}
          className={cx({ error: touched && error })}
        />
        {touched &&
          ((error && (
            <span className="tiny-message error">
              <i>{error}</i>
            </span>
          )) ||
            (warning && (
              <span className="tiny-message warning">
                <i>{warning}</i>
              </span>
            )))}
      </Form.Field>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SemanticFormField.js